/**
 * Transition slide left to right (or inverted)
 */
class TransitionSlideLeftRight {
  /**
   * @param {Boolean} [inverted=false] - If true, slides from right to left instead
   * @param {Number} [transitionLength=1.5] - Total duration of the transition (half for In, half for Out)
   */
  constructor(inverted = false, transitionLength = 1.5) {
    this.transitionLength = transitionLength;
    this.isInverted = inverted;
    this.mask = $('#barba-transition').find('.rect');
  }

  /**
   * @returns {Promise}
   */
  animateIn() {
    return new Promise(resolve => {
      let tl = new gsap.timeline({ onComplete: resolve });
      let transformOrigin = this.isInverted ? '100% 50%' : '0% 50%';

      tl.add(gsap.set(this.mask, { 'transform-origin': transformOrigin, scaleX: 0, scaleY: 1 }));
      tl.add(gsap.to(this.mask, this.transitionLength / 2, { scaleX: 1, ease: Power2.easeOut }));
    });
  }

  /**
   * @returns {Promise}
   */
  animateOut() {
    return new Promise(resolve => {
      let tl = new gsap.timeline({ onComplete: resolve });
      let transformOrigin = this.isInverted ? '0% 50%' : '100% 50%';

      tl.add(gsap.set(this.mask, { 'transform-origin': transformOrigin }));
      tl.add(gsap.to(this.mask, this.transitionLength / 2, { scaleX: 0, ease: Power2.easeOut }));
    });
  }
}

const barbaTransition = new TransitionSlideLeftRight();